import { ChangeDetectorRef, Component, EventEmitter, inject, input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { DatePipe, AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, Subject, map, shareReplay, takeUntil } from 'rxjs';

// translation service
import { TranslatePipe } from '@ngx-translate/core';

// Angular Material
import { MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { Sort, MatSort, MatSortModule } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

// models
import { IPagedData, IPaginatorOptions } from '../../services/common-service';
import { TableColumn } from '../../services/client-service';

@Component( {
  selector: 'app-paged-datatable-component',
  imports: [
    DatePipe,
    AsyncPipe,
    TranslatePipe,
    RouterLink,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatInputModule,
    MatFormFieldModule,
  ],
  templateUrl: './paged-datatable-component.html',
  styleUrl: './paged-datatable-component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
} )
export class PagedDatatableComponent implements OnInit
{
  constructor( private _cdr: ChangeDetectorRef ) { }

  @ViewChild( MatPaginator ) paginator!: MatPaginator;
  @ViewChild( MatSort ) sort!: MatSort;

  private breakpointObserver = inject( BreakpointObserver );
  private destroy$ = new Subject<void>();

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe( Breakpoints.Handset )
    .pipe(
      map( result => result.matches ),
      shareReplay( { refCount: true, bufferSize: 1 } ),
      takeUntil( this.destroy$ )
    );

  protected data: any[] | undefined;

  @Output() pagedDatatablePageChange = new EventEmitter<PageEvent>();
  @Output() pagedDatatableSortChange = new EventEmitter<Sort>();

  public columns = input<TableColumn[]>( [] );
  public displayedColumns: string[]=[];
  public status: | 'loading' | 'loaded' | 'error' = 'loading';
  public paginatorOptions:IPaginatorOptions = { pageSizeOptions: [10, 20, 50, 100], pageIndex: 0, length: 0 };

  ngOnInit(): void
  {
    this.displayedColumns = this.columns().filter( c => !!c.field ).map( c => c.field! );
    this._cdr.detectChanges();
  }

  public loadData( pagedData: IPagedData, paginator: IPaginatorOptions ): void
  {
    this.status = 'loading';
    this.data = undefined;
    this.data = pagedData.data;
    this.paginatorOptions = paginator;
    this.status = 'loaded';
    this._cdr.detectChanges();
  }

  pageChanged( event: PageEvent ): void
  {
    this.pagedDatatablePageChange.emit( event );
  }

  sortChange( sort: Sort ): void
  {    
    this.pagedDatatableSortChange.emit( sort );
  }
}
